
<mwp-benefit-enrollment-category-header [enrollmentManager]="enrollmentManagerService.manager" />

@if (isBenefitSelectionPanel) {
  <mwp-benefit-enrollment-wizard-selection [benefitSelection]="benefitSelection" (emitComplete)="completePanel($event)" />
}
@if (isKitBenefitPanel) {
  <mwp-benefit-enrollment-wizard-selection [kitBenefitCollection]="kitBenefitCollection"  (emitComplete)="completePanel($event)"/>
}
@if (isKitBuyupBenefitPanel) {
  <mwp-benefit-enrollment-wizard-selection [kitBuyUpBenefitCollection]="kitBuyUpBenefitCollection"  (emitComplete)="completePanel($event)"/>
}
@if (isFutureBenefitPanel) {
  <mwp-benefit-enrollment-wizard-selection [benefitSelection]="futureBenefitSelection"  (emitComplete)="completePanel($event)"/>
}
@if (isCoreBenefitPanel) {
  <mwp-benefit-enrollment-wizard-core-benefit [coreBenefitResponse]="coreBenefitResponse" (emitComplete)="completePanel($event)" />
}
@if (isTobaccoUsagePanel) {
  <mwp-benefit-enrollment-wizard-tobacco-usage [tobaccoModel]="tobaccoModel" (emitComplete)="completePanel($event)" />
}
@if (isCoveragePanel) {
  <mwp-benefit-enrollment-wizard-coverage [coverageTab]="coverageTab" (emitReload)="reloadPanel()" (emitComplete)="completePanel($event)" />
}
@if (isEligibilityPanel) {
  <mwp-benefit-enrollment-wizard-eligibility [eligibility]="eligibility" (emitComplete)="completePanel($event)" />
}
@if (isPcpPanel) {
  <mwp-benefit-enrollment-wizard-pcp [pcpModel]="pcpModel" (emitComplete)="completePanel($event)" />
}
@if (isCarrierModulePanel) {
  <mwp-benefit-enrollment-wizard-carrier-module [additionalModuleBase]="additionalModuleBase" (emitComplete)="completePanel($event)"/>
}
@if (isBeneficiariesPanel) {
  <mwp-benefit-enrollment-wizard-beneficiaries [beneficiariesResponse]="beneficiariesResponse" (emitComplete)="completePanel($event)" (emitCancel)="cancelWizard()" />
}
@if (isRequestTermPanel) {
  <mwp-benefit-enrollment-wizard-request-term [cancelBenefit]="cancelBenefit" (emitComplete)="completePanel($event)" />
}
@if (isAutoEnrollPanel) {
  <mwp-benefit-enrollment-wizard-auto-benefit [autoEnrollResponse]="autoEnrollResponse" (emitComplete)="completePanel($event)" />
}
@if (isAutoTermPanel) {
  <mwp-benefit-enrollment-wizard-auto-benefit [autoTermResponse]="autoTermResponse" (emitComplete)="completePanel($event)" />
}
@if (isCancelRequestPanel) {
  <mwp-benefit-enrollment-wizard-cancel-request [cancelBenefit]="cancelEnrollmentRequest" (emitComplete)="completePanel($event)" />
}
@if (isDisclaimerPanel) {
  <mwp-benefit-enrollment-wizard-disclaimer [disclaimer]="disclaimer" (emitComplete)="completePanel($event)" />
}
@if (isFutureBenefitsDisclaimerPanel) {
  <mwp-benefit-enrollment-wizard-disclaimer [futureBenefitsDisclaimer]="futureBenefitsDisclaimer" (emitComplete)="completePanel($event)" />
}
@if (isSummaryPanel) {
  <mwp-benefit-enrollment-wizard-summary [summaryList]="benefitSummary" (emitComplete)="completePanel($event)" />
}

@if (isLoading) {
  <mwp-placeholder-table [displayButton]="true" />
}
@if (isNotConfigured) {
  <mwp-wizard-error/>
}